import SiteHeader from "./features/tomasConnect/shared/SiteHeader";
import VisitCounter from "./components/commons/VisitCounter";
import SiteFooter from "./features/tomasConnect/shared/SiteFooter";

export default function AppLayout({ children, overlayHeader = false, loginPage = false }) {
  return (
    <div className={`tc-site-layout${overlayHeader ? " tc-site-layout-overlay" : ""}${loginPage ? " tc-site-layout-login" : ""}`}>
      <VisitCounter />
      <SiteHeader />
      {children}
      <SiteFooter />
    </div>
  );
}
